/* MiaMia · personalizador propio (reemplaza a Globo).
   Pinta los campos de grabado por pasos, con vista previa de la placa,
   contador de caracteres, ejemplos y confirmación de ortografía.
   Los campos viajan como properties[<prop>] del line item, con los MISMOS
   nombres que mandaba Globo, para que el agente de órdenes los siga leyendo.
   Los add-ons con precio se agregan al carrito como líneas aparte justo antes
   de que el theme agregue el producto. */
(function () {
  if (customElements.get('mm-personalizer')) return;

  var METALS = {
    silver: ['#eef0f2', '#c9ced3', '#4a4f55'], gold: ['#f3dfa8', '#cfa75a', '#5a4219'],
    'rose gold': ['#f4d3c6', '#d59c88', '#6b3a2c'], rose: ['#f4d3c6', '#d59c88', '#6b3a2c'],
    black: ['#4a4a4a', '#1e1e1e', '#e9e9e9'], red: ['#e05a5a', '#b52a2a', '#fbe9e9'],
    'hot pink': ['#f27ab7', '#d23a8a', '#fff0f7'], pink: ['#f6b6cf', '#e07ea6', '#fff3f8'],
    'light pink': ['#f9d3e2', '#eba9c3', '#5a3442'], 'light blue': ['#a8d4f2', '#6aaedd', '#173b55'],
    'baby blue': ['#bfe1f7', '#86c1e8', '#173b55'], blue: ['#6f9fe0', '#2e64b8', '#eef4ff'],
    'dark blue': ['#3d5a99', '#1d3366', '#e8eefc'], green: ['#7cc38e', '#3f9158', '#f0fbf3'],
    'light green': ['#b5e3a8', '#7ec46a', '#1f3d18'], 'olive green': ['#a3a86d', '#6e733c', '#f6f7ec'],
    'bright green': ['#8ee07a', '#4fb53a', '#123b0b'], yellow: ['#f6e27a', '#d9bd2f', '#4a3d05'],
    purple: ['#b28be0', '#7b4fb6', '#f6f0ff'], orange: ['#f7a65c', '#e07a1e', '#3d2006'],
    white: ['#ffffff', '#e6e6e6', '#5a5a5a'], grey: ['#c4c4c4', '#8f8f8f', '#202020'],
    brown: ['#a07850', '#6e4c2c', '#f7efe6']
  };
  // Símbolo médico = el mismo vector de las órdenes (medic_symbol_grueso.ai del agente, MEDIC_SYMBOL_NEW_PATHS), en unidades 0..100.
  var MED_SYMBOL = { w: 100, h: 98.60, d: ['M100.00 38.40L84.20 11.02L65.78 21.85L65.78 0.00L34.20 0.00L34.20 21.85L15.80 11.02L0.00 38.39L18.52 49.30L0.00 60.21L15.80 87.58L34.20 76.75L34.20 98.60L65.78 98.60L65.78 76.75L84.20 87.58L100.00 60.21L81.46 49.30L100.00 38.40ZM38.92 68.49C38.12 68.03 37.15 68.04 36.35 68.50L17.98 79.32L8.19 62.37L26.62 51.51C27.40 51.05 27.88 50.21 27.88 49.30C27.88 48.39 27.40 47.56 26.62 47.09L8.19 36.24L17.98 19.28L36.35 30.10C37.14 30.56 38.12 30.57 38.92 30.11C39.72 29.66 40.21 28.81 40.21 27.89L40.21 6.01L59.77 6.01L59.77 27.89C59.77 28.81 60.26 29.66 61.06 30.11C61.86 30.57 62.83 30.56 63.63 30.10L82.02 19.28L91.81 36.24L73.34 47.09C72.56 47.55 72.08 48.39 72.08 49.30C72.08 50.21 72.56 51.05 73.34 51.51L91.81 62.37L82.02 79.32L63.63 68.50C62.83 68.03 61.85 68.03 61.06 68.49C60.26 68.94 59.77 69.79 59.77 70.71L59.77 92.59L40.21 92.59L40.21 70.71C40.21 69.79 39.72 68.94 38.92 68.49Z', 'M41.16 59.67L41.75 60.14L42.35 59.68C43.23 58.99 44.28 58.45 45.45 58.05L47.99 57.26L45.53 56.24C44.95 55.99 44.43 55.67 44.05 55.34C44.31 55.21 44.55 55.06 44.79 54.89C46.78 53.45 47.57 51.07 46.59 49.47C46.16 48.76 45.43 48.30 44.54 48.16C43.27 47.97 41.81 48.47 40.65 49.50C38.69 51.19 38.44 53.02 38.44 54.42C38.44 55.58 38.79 57.79 41.16 59.67ZM41.55 51.30C41.55 50.72 42.02 50.25 42.59 50.25C42.70 50.25 42.81 50.28 42.91 50.31C43.33 50.45 43.63 50.83 43.63 51.30C43.63 51.89 43.16 52.36 42.59 52.36C42.03 52.36 41.58 51.90 41.56 51.34C41.56 51.32 41.55 51.31 41.55 51.30Z', 'M59.38 49.50C58.21 48.47 56.74 47.96 55.48 48.16C54.59 48.30 53.86 48.76 53.43 49.47C52.45 51.07 53.25 53.45 55.23 54.89C55.47 55.06 55.72 55.21 55.97 55.34C55.78 55.50 55.56 55.67 55.31 55.81C54.52 56.29 53.95 56.47 50.79 57.50C49.57 57.90 47.97 58.42 45.83 59.13C42.54 60.25 40.57 62.54 40.57 65.26C40.57 67.01 41.38 68.59 42.92 69.81L43.60 70.36L44.21 69.73C44.86 69.05 45.68 68.47 46.64 68.00L47.51 67.58L47.51 67.61L52.52 65.37L52.52 64.13C54.28 64.79 54.44 65.15 54.44 65.26C54.44 65.99 51.56 67.17 50.02 67.80C48.53 68.42 46.98 69.05 45.91 69.79C44.33 70.88 43.50 72.32 43.50 73.96C43.50 75.03 43.72 76.28 45.31 77.39C45.91 77.88 46.50 77.72 46.82 77.45C47.30 77.03 47.35 76.30 46.96 75.63C46.71 75.14 46.79 74.92 46.82 74.85C46.91 74.61 47.18 74.37 47.51 74.16L47.51 77.86C47.51 79.25 48.63 80.37 50.01 80.37C51.40 80.37 52.52 79.25 52.52 77.86L52.52 74.21C53.02 74.57 53.17 74.85 53.22 74.99C53.24 75.07 53.31 75.28 53.07 75.68C52.59 76.51 52.81 77.14 53.17 77.46C53.50 77.74 54.09 77.89 54.70 77.41C56.27 76.21 56.49 75.06 56.49 73.98C56.49 72.87 56.08 71.81 55.31 70.90C58.06 69.57 59.45 67.68 59.45 65.26C59.45 63.53 58.65 61.96 57.19 60.75C57.38 60.65 57.58 60.54 57.79 60.41C61.09 58.44 61.59 55.81 61.59 54.42C61.58 53.02 61.33 51.19 59.38 49.50ZM57.41 50.25C57.98 50.25 58.45 50.72 58.45 51.30C58.45 51.31 58.44 51.31 58.44 51.31C58.44 51.89 57.98 52.36 57.41 52.36C56.83 52.36 56.37 51.89 56.37 51.30C56.37 50.83 56.67 50.45 57.09 50.31C57.19 50.28 57.29 50.25 57.41 50.25ZM47.51 66.71L46.64 66.28C45.58 65.74 45.58 65.53 45.58 65.26C45.58 65.15 45.74 64.79 47.51 64.13L47.51 66.71Z', 'M41.40 45.89C42.14 46.63 43.16 47.06 44.23 47.06L44.27 47.06L44.27 47.06C45.69 47.05 46.90 46.17 47.49 44.91L47.49 56.11L52.51 54.50L52.51 46.63C52.74 46.47 52.95 46.29 53.14 46.09C54.68 47.39 57.18 47.30 58.60 45.89C59.55 46.51 60.71 46.85 61.92 46.86C63.55 46.88 65.05 46.28 66.09 45.24L66.77 44.56L65.96 43.75C66.62 43.73 67.27 43.59 67.90 43.33C69.28 42.76 70.35 41.68 70.92 40.31L71.29 39.41L69.51 38.68C71.57 37.66 72.54 35.67 72.54 33.77L72.54 32.81L61.02 32.81C58.93 32.81 57.08 33.64 55.38 35.34C54.80 35.91 54.35 36.67 53.92 37.40C53.40 38.27 52.97 38.95 52.51 39.35L52.51 36.93C53.47 36.17 54.05 35.00 54.05 33.77C54.05 31.54 52.23 29.72 50.00 29.72C47.77 29.72 45.95 31.54 45.95 33.77C45.95 35.00 46.53 36.17 47.49 36.93L47.49 39.33C46.98 38.89 46.52 38.13 46.08 37.40C45.64 36.67 45.19 35.91 44.62 35.34C42.92 33.64 41.07 32.81 38.98 32.81L27.46 32.81L27.46 33.77C27.46 35.73 28.41 37.69 30.46 38.69L28.71 39.42L29.08 40.31C29.94 42.39 31.92 43.67 34.04 43.75L33.23 44.56L33.91 45.24C35.83 47.16 39.14 47.37 41.40 45.89Z'] };
  var FONTS = {
    'arial': 'Arial, Helvetica, sans-serif', 'arial bold': 'Arial, Helvetica, sans-serif',
    'monotype': '"Monotype Corsiva", "Apple Chancery", "URW Chancery L", cursive',
    'montype': '"Monotype Corsiva", "Apple Chancery", "URW Chancery L", cursive',
    'waltograph': '"Waltograph", "Comic Sans MS", cursive'
  };


  // 23-oct-2026 (María): símbolos que se meten DENTRO del texto con un botón. Se ven con la fuente
  // mm-sym (códigos privados U+E001…); en la orden van como "(heart)", que es lo que lee el agente.
  var SYM = { 'heart': '\uE001', 'paw': '\uE002', 'right wing': '\uE003', 'left wing': '\uE004',
    'infinity': '\uE005', 'star': '\uE006', 'mickey': '\uE007', 'minnie': '\uE008' };
  var SYM_NAME = {}; Object.keys(SYM).forEach(function (k) { SYM_NAME[SYM[k]] = k; });
  function symToText(v) { return v.replace(/[\uE001-\uE008]/g, function (c) { return '(' + SYM_NAME[c] + ')'; }); }
  function textToSym(v) { return v.replace(/\((heart|paw|right wing|left wing|infinity|star|mickey|minnie)\)/gi, function (m, k) { return SYM[k.toLowerCase()]; }); }

  // 23-oct-2026 (María): reverso del Handwriting Pendant — una sola caja de
  // texto que se reparte en líneas de N caracteres (sin cortar palabras si se
  // puede). La MISMA regla usa el agente al diseñar (etsy_agent_v1._hw_partir).
  function wrapText(v, w) {
    var out = [], cur = '';
    String(v || '').trim().split(/\s+/).forEach(function (word) {
      if (!word) return;
      while (word.length > w) { if (cur) { out.push(cur); cur = ''; } out.push(word.slice(0, w)); word = word.slice(w); }
      if (!word) return;
      if (!cur) cur = word;
      else if ((cur + ' ' + word).length <= w) cur += ' ' + word;
      else { out.push(cur); cur = word; }
    });
    if (cur) out.push(cur);
    return out;
  }

  function el(tag, attrs, kids) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) {
      if (k === 'text') e.textContent = attrs[k];
      else if (k === 'html') e.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') e.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] !== false && attrs[k] != null) e.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c) e.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return e;
  }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function money(p) { return '+$' + Number(p).toFixed(2); }

  class MMPersonalizer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.cfg = JSON.parse(this.querySelector('[data-mm-pz-config]').textContent);
        this.prod = JSON.parse(this.querySelector('[data-mm-pz-product]').textContent);
      } catch (e) { console.error('mm-pz config', e); return; }
      this.formId = this.dataset.formId;
      this.values = {};
      this.side = null;
      this.fields = this.cfg.fields.map(function (f, i) { f._id = 'mmpz-' + i; return f; });
      this.render();
      this.bindForm();
      this.update();
    }

    /* ── estado ── */
    form() { return document.getElementById(this.formId); }
    variantTitle() {
      var f = this.form(); var idIn = f && f.querySelector('input[name="id"]');
      var id = idIn ? Number(idIn.value) : null;
      var v = this.prod.variants.find(function (x) { return x.id === id; }) || this.prod.variants[0];
      return (v && v.title || '').toLowerCase();
    }
    visible(f) {
      var s = f.show_if; if (!s) return true;
      if (s.variant) return this.variantTitle().indexOf(s.variant.toLowerCase()) !== -1;
      for (var key in s) {
        var src = this.fields.find(function (x) { return x.key === key; });
        if (!src) continue;
        if (s[key].indexOf(this.values[src._id] || '') === -1) return false;
      }
      return true;
    }
    pick(key) {
      var f = this.fields.find(function (x) { return x.key === key; });
      if (f) return (this.values[f._id] || f.default || '').toLowerCase();
      return '';
    }
    metal() {
      // Placa de acero fija aunque la variante cambie el color de la banda (María, 22-oct-2026)
      if (this.cfg.metal && METALS[this.cfg.metal]) return METALS[this.cfg.metal];
      var c = this.pick('color');
      if (!c) {
        // color tomado de la variante (p. ej. "Silver", "Gold / One side", "Black/silver")
        var vt = this.variantTitle();
        var keys = Object.keys(METALS).sort(function (a, b) { return b.length - a.length; });
        for (var i = 0; i < keys.length; i++) if (vt.indexOf(keys[i]) !== -1) { c = keys[i]; break; }
      }
      c = (c || 'silver').replace(/^\d+\.\s*/, '');
      var key = Object.keys(METALS).sort(function (a, b) { return b.length - a.length; })
        .find(function (k) { return c.indexOf(k) !== -1; });
      return METALS[key || 'silver'];
    }
    font() {
      var f = this.pick('font');
      if (!f) { var vt = this.variantTitle(); f = /arial bold/.test(vt) ? 'arial bold' : /monotype/.test(vt) ? 'monotype' : /waltograph/.test(vt) ? 'waltograph' : 'arial'; }
      f = f.replace(/^\d+\.\s*/, '');
      return { family: FONTS[f] || FONTS.arial, weight: /bold/.test(f) ? 700 : 400 };
    }

    /* ── pintar ── */
    render() {
      var self = this;
      var hasText = this.fields.some(function (f) { return f.type === 'line' || f.type === 'area'; });
      var wrap = el('div', { class: 'mm-pz__inner' });

      // Paso 1: opciones (las que no son texto)
      var opts = this.fields.filter(function (f) { return f.type === 'choice' && !f.after; });
      var step = 1;
      if (opts.length) {
        var s1 = el('section', { class: 'mm-pz__step' }, [el('h3', { class: 'mm-pz__h' }, [el('span', { class: 'mm-pz__n', text: String(step++) }), 'Choose your options'])]);
        opts.forEach(function (f) { s1.appendChild(self.renderChoice(f)); });
        wrap.appendChild(s1);
      }

      // Paso 2: grabado + vista previa
      var texts = this.fields.filter(function (f) { return f.type !== 'choice'; });
      if (texts.length) {
        var s2 = el('section', { class: 'mm-pz__step' }, [el('h3', { class: 'mm-pz__h' }, [el('span', { class: 'mm-pz__n', text: String(step++) }),
          this.cfg.title || (hasText ? 'Your engraving' : 'Your design')])]);
        if (hasText) {
          this.preview = el('div', { class: 'mm-pz__preview', 'aria-hidden': 'true' });
          this.sideTabs = el('div', { class: 'mm-pz__sides', role: 'tablist' });
          s2.appendChild(el('div', { class: 'mm-pz__previewwrap' }, [this.preview, this.sideTabs,
            el('p', { class: 'mm-pz__note', text: 'Preview is approximate. Your piece is made exactly as typed.' })]));
        }
        this.hint = el('p', { class: 'mm-pz__hint', text: 'Choose your engraving option above to type your text.', hidden: true });
        s2.appendChild(this.hint);
        texts.forEach(function (f) { s2.appendChild(self.renderText(f)); });
        if (this.cfg.medical && hasText) {
          s2.appendChild(el('p', { class: 'mm-pz__help' }, ['Not sure what to engrave? ',
            el('a', { href: this.prod.guide, target: '_blank', rel: 'noopener', text: 'See examples by condition' }),
            /bracelet/i.test(this.prod.title) ? ' · ' : null,
            /bracelet/i.test(this.prod.title) ? el('a', { href: '/pages/size-guide', target: '_blank', rel: 'noopener', text: 'Size guide' }) : null]));
        }
        wrap.appendChild(s2);
      }

      // 25-oct-2026 (María): opciones que van DESPUÉS del grabado (ej. llavero o
      // tarjeta médica extra con la misma información), en su propio paso.
      var after = this.fields.filter(function (f) { return f.type === 'choice' && f.after; });
      if (after.length) {
        var s3 = el('section', { class: 'mm-pz__step' }, [el('h3', { class: 'mm-pz__h' }, [el('span', { class: 'mm-pz__n', text: String(step++) }),
          after[0].step_title || 'Add an extra'])]);
        after.forEach(function (f) { s3.appendChild(self.renderChoice(f)); });
        wrap.appendChild(s3);
      }

      // Confirmación de ortografía: solo si hay texto escrito (no en fichas de solo archivo)
      if (hasText) {
      var chk = el('input', { type: 'checkbox', id: 'mmpz-ok-' + this.dataset.section, class: 'mm-pz__okbox' });
      chk.addEventListener('change', function () { self.okErr.hidden = true; });
      this.okBox = chk;
      this.okErr = el('p', { class: 'mm-pz__err', text: 'Please confirm your engraving before adding to cart.', hidden: true });
      wrap.appendChild(el('div', { class: 'mm-pz__ok' }, [
        el('label', { for: chk.id, class: 'mm-pz__oklabel' }, [chk, el('span', { text: 'I checked the spelling and line order. My piece will be made exactly as typed.' })]),
        this.okErr]));
      }

      this.appendChild(wrap);
    }

    renderChoice(f) {
      var self = this;
      var box = el('div', { class: 'mm-pz__field', 'data-fid': f._id });
      var info = null;
      if (f.info) {
        info = el('button', { type: 'button', class: 'mm-pz__info', 'aria-label': 'More information', 'aria-expanded': 'false' }, ['i']);
        var tip = el('span', { class: 'mm-pz__tip', role: 'tooltip', text: f.info, hidden: true });
        info.addEventListener('click', function () { tip.hidden = !tip.hidden; info.setAttribute('aria-expanded', String(!tip.hidden)); });
        info.addEventListener('mouseenter', function () { tip.hidden = false; });
        info.addEventListener('mouseleave', function () { tip.hidden = true; });
        info = el('span', { class: 'mm-pz__infowrap' }, [info, tip]);
      }
      box.appendChild(el('div', { class: 'mm-pz__label' }, [f.label, info, f.required ? el('span', { class: 'mm-pz__req', text: ' *' }) : null]));
      var group = el('div', { class: 'mm-pz__opts mm-pz__opts--' + (f.style || 'buttons') + (f.swatch ? ' mm-pz__opts--swatch' : ''), role: 'radiogroup', 'aria-label': f.label });
      f.options.forEach(function (o, i) {
        var id = f._id + '-' + i;
        var inp = el('input', { type: 'radio', name: f._id, id: id, value: o.v, class: 'mm-pz__radio' });
        if ((f.default && f.default === o.v)) { inp.checked = true; self.values[f._id] = o.v; }
        inp.addEventListener('change', function () { self.values[f._id] = o.v; self.clearErr(f); self.update(); });
        var dot = null;
        if (f.swatch) { var ov = o.v.toLowerCase(); var mk = Object.keys(METALS).sort(function (a, b) { return b.length - a.length; }).find(function (k) { return ov.indexOf(k) !== -1; }); var m = METALS[mk] || METALS.silver; dot = el('span', { class: 'mm-pz__dot', style: 'background:linear-gradient(135deg,' + m[0] + ',' + m[1] + ')' }); }
        group.appendChild(inp);
        if (f.style === 'cards') {
          // Tarjeta con foto: o.img = archivo en assets, o 'product' = primera foto del producto
          var js = document.querySelector('script[src*="mm-pz.js"]'), src = '';
          if (o.img === 'product') src = (self.prod.images || [])[0] || '';
          else if (o.img && js) src = js.src.replace(/mm-pz\.js.*$/, o.img);
          var vtxt = o.v.replace('{item}', self.itemWord());
          group.appendChild(el('label', { for: id, class: 'mm-pz__opt mm-pz__card' }, [
            el('span', { class: 'mm-pz__cardimg' + (src ? '' : ' mm-pz__cardimg--none') }, [src ? el('img', { src: src, alt: '', loading: 'lazy', width: '300', height: '300' }) : null]),
            el('span', { class: 'mm-pz__cardtxt', text: vtxt }),
            o.price ? el('span', { class: 'mm-pz__price', text: money(o.price) }) : null]));
          return;
        }
        group.appendChild(el('label', { for: id, class: 'mm-pz__opt' }, [dot, (f.prefix || '') + o.v,
          o.price ? el('span', { class: 'mm-pz__price', text: money(o.price) }) : null]));
      });
      box.appendChild(group);
      // 22-oct-2026 (María): ya no se muestra la foto con todas las opciones; la vista previa dibuja la opción elegida.
      if (f.help) box.appendChild(el('p', { class: 'mm-pz__help', text: f.help }));
      // la property real que viaja al carrito
      f._hidden = el('input', { type: 'hidden', name: 'properties[' + f.prop + ']', form: this.formId, disabled: true });
      box.appendChild(f._hidden);
      box.appendChild(el('p', { class: 'mm-pz__err', text: 'Please choose an option.', hidden: true }));
      return box;
    }

    renderText(f) {
      var self = this;
      var box = el('div', { class: 'mm-pz__field mm-pz__field--' + f.type, 'data-fid': f._id });
      box.appendChild(el('label', { class: 'mm-pz__label', for: f._id + '-0' }, [f.label, f.required ? el('span', { class: 'mm-pz__req', text: ' *' }) : null,
        f.max && f.type !== 'file' ? el('span', { class: 'mm-pz__limit', text: (f.type === 'area' ? f.lines + ' lines · ' : '') + 'up to ' + f.max + ' characters' + (f.type === 'area' ? ' each' : '') }) : null]));
      if (f.type === 'file') {
        var fi = el('input', { type: 'file', id: f._id + '-0', name: 'properties[' + f.prop + ']', form: this.formId, accept: f.accept || 'image/*,.pdf,.heic', class: 'mm-pz__file' });
        fi.addEventListener('change', function () {
          self.values[f._id] = fi.files.length ? fi.files[0].name : '';
          if (f.key === 'logo') { try { self.logoURL = fi.files.length && /^image\//.test(fi.files[0].type) ? URL.createObjectURL(fi.files[0]) : ''; } catch (e) { self.logoURL = ''; } }
          self.clearErr(f); self.update();
        });
        f._inputs = [fi];
        box.appendChild(fi);
      } else {
        var n = f.type === 'area' ? f.lines : 1;
        f._inputs = [];
        for (var i = 0; i < n; i++) {
          var ph = textToSym(f.type === 'area' ? (f.ph[i] || '') : (f.ph || ''));
          var inp = el('input', { type: 'text', id: f._id + '-' + i, class: 'mm-pz__input', maxlength: f.max || 60, placeholder: ph, autocomplete: 'off',
            'aria-label': f.type === 'area' ? f.label + ' line ' + (i + 1) : f.label, spellcheck: 'true' });
          var cnt = el('span', { class: 'mm-pz__count', text: '0/' + (f.max || 60) });
          inp.addEventListener('input', (function (inp, cnt) { return function () {
            cnt.textContent = inp.value.length + '/' + (f.max || 60);
            cnt.classList.toggle('is-full', inp.value.length >= (f.max || 60));
            self.clearErr(f); self.update();
          }; })(inp, cnt));
          inp.addEventListener('focus', function () { self.lastInput = this; if (f.side) { self.side = f.side; self.update(); } });
          f._inputs.push(inp);
          box.appendChild(el('div', { class: 'mm-pz__row' }, [f.type === 'area' ? el('span', { class: 'mm-pz__ln', text: String(i + 1) }) : null, inp, cnt]));
        }
        if (f.symbols && f.symbols.length) {
          var syms = el('div', { class: 'mm-pz__syms', role: 'group', 'aria-label': 'Add a symbol' }, [el('span', { class: 'mm-pz__symlbl', text: 'Add a symbol:' })]);
          f.symbols.forEach(function (k) {
            if (!SYM[k]) return;
            var b = el('button', { type: 'button', class: 'mm-pz__sym', title: k, 'aria-label': 'Add ' + k }, [el('span', { class: 'mm-pz__symg', text: SYM[k] })]);
            b.addEventListener('mousedown', function (e) { e.preventDefault(); });   // que no se pierda el cursor del cajetín
            b.addEventListener('click', function () {
              var t = (self.lastInput && f._inputs.indexOf(self.lastInput) !== -1) ? self.lastInput : f._inputs[0];
              var max = Number(t.getAttribute('maxlength')) || 60;
              if (t.value.length >= max) { t.focus(); return; }
              var a = t.selectionStart == null ? t.value.length : t.selectionStart, z = t.selectionEnd == null ? a : t.selectionEnd;
              if (document.activeElement !== t) { a = z = t.value.length; }
              t.value = t.value.slice(0, a) + SYM[k] + t.value.slice(z);
              t.focus(); t.setSelectionRange(a + 1, a + 1);
              self.lastInput = t;
              t.dispatchEvent(new Event('input'));
            });
            syms.appendChild(b);
          });
          box.appendChild(syms);
        }
        f._hidden = el('input', { type: 'hidden', name: 'properties[' + f.prop + ']', form: this.formId, disabled: true });
        box.appendChild(f._hidden);
      }
      if (f.help) box.appendChild(el('p', { class: 'mm-pz__help', text: f.help }));
      box.appendChild(el('p', { class: 'mm-pz__err', text: f.err || (f.type === 'file' ? 'Please upload a photo.' : 'Please fill in at least the first line.'), hidden: true }));
      return box;
    }

    insertChip(text) {
      var vis = this.fields.filter(function (f) { return (f.type === 'line' || f.type === 'area') && this.visible(f); }, this);
      var inputs = [];
      vis.forEach(function (f) { inputs = inputs.concat(f._inputs); });
      var target = (this.lastInput && inputs.indexOf(this.lastInput) !== -1 && !this.lastInput.value) ? this.lastInput
        : inputs.find(function (i) { return !i.value; });
      if (!target) target = this.lastInput || inputs[inputs.length - 1];
      if (!target) return;
      var max = Number(target.getAttribute('maxlength')) || 60;
      target.value = text.length > max ? text.slice(0, max) : text;
      target.dispatchEvent(new Event('input'));
      target.focus();
      if (text === 'ICE: ') target.setSelectionRange(target.value.length, target.value.length);
    }

    textOf(f) {
      if (!f._inputs) return '';
      var vals = f._inputs.map(function (i) { return symToText(i.value).trim(); });
      if (f.type === 'line') return vals[0];
      if (f.type === 'file') return this.values[f._id] || '';
      var last = vals.length; while (last > 0 && !vals[last - 1]) last--;
      vals = vals.slice(0, last);
      if (!vals.some(Boolean)) return '';
      return f.fmt === 'numbered' ? vals.map(function (v, i) { return 'Line ' + (i + 1) + ': ' + v; }).join('\n') : vals.join('\n');
    }

    /* ── actualizar visibilidad, properties y vista previa ── */
    update() {
      var self = this;
      this.fields.forEach(function (f) {
        var on = self.visible(f);
        var box = self.querySelector('[data-fid="' + f._id + '"]');
        if (box) box.hidden = !on;
        var val = f.type === 'choice' ? (self.values[f._id] || '') : self.textOf(f);
        // opciones "no quiero el extra" (o.none): no viajan como property
        if (f.type === 'choice' && val && f.options.some(function (o) { return o.v === val && o.none; })) val = '';
        if (f._hidden) { f._hidden.value = val; f._hidden.disabled = !on || !val; }
        if (f.type === 'file') f._inputs[0].disabled = !on;
      });
      if (this.hint) {
        var anyVis = this.fields.some(function (f) { return f.type !== 'choice' && self.visible(f); });
        this.hint.hidden = anyVis;
        if (this.preview) this.preview.parentNode.hidden = !anyVis && !this.cfg.qr;   // con QR la placa se ve aunque sea "solo QR"
      }
      this.drawPreview();
      this.fitText();
      this.showTotal();
    }

    // 23-oct-2026 (María): el precio de arriba muestra el TOTAL con las opciones
    // que cobran extra (antes se quedaba en el precio base y el cambio aparecía
    // recién en el checkout). Dawn redibuja el precio al cambiar de variante,
    // así que un observer lo vuelve a poner.
    showTotal() {
      var box = document.getElementById('price-' + this.dataset.section);
      if (!box) return;
      var self = this;
      var f = this.form(); var idIn = f && f.querySelector('input[name="id"]');
      var id = idIn ? Number(idIn.value) : null;
      var v = this.prod.variants.find(function (x) { return x.id === id; }) || this.prod.variants[0];
      if (!v || v.price == null) return;
      var extra = 0;
      this.fields.forEach(function (fl) {
        if (fl.type !== 'choice' || !self.visible(fl)) return;
        var o = fl.options.find(function (x) { return x.v === self.values[fl._id]; });
        if (o && o.addon && o.price) extra += Math.round(parseFloat(o.price) * 100) * (o.qty || 1);
      });
      var total = (v.price + extra) / 100;
      if (this._priceObs) { this._priceObs.disconnect(); this._priceObs.takeRecords(); }   // que mis cambios no lo disparen
      this._pricing = true;
      box.querySelectorAll('.price__regular .price-item--regular, .price-item--sale').forEach(function (el) {
        if (!el.dataset.mmBase) el.dataset.mmBase = el.textContent;
        el.textContent = el.dataset.mmBase.replace(/\d[\d,]*(\.\d{2})?/, total.toFixed(2));
      });
      var note = box.querySelector('.mm-pz__pricenote');
      if (extra && !note) { note = document.createElement('small'); note.className = 'mm-pz__pricenote'; note.textContent = 'Includes your selected options'; box.appendChild(note); }
      if (note) note.hidden = !extra;
      this._pricing = false;
      if (!this._priceObs) this._priceObs = new MutationObserver(function () { if (!self._pricing) self.showTotal(); });
      this._priceObs.observe(box, { childList: true, subtree: true, characterData: true });
    }

    // 23-oct-2026 (María): el texto no puede salirse de la placa. El ancho por
    // letra es una estimación (mayúsculas y símbolos son más anchos), así que
    // después de dibujar se mide de verdad y, si se pasa, se achica.
    fitText() {
      if (!this.preview) return;
      var self = this;
      this.preview.querySelectorAll('g.mm-pz__txt').forEach(function (g) {
        var rot = g.getAttribute('data-rot') || '';
        if (rot) g.setAttribute('transform', rot); else g.removeAttribute('transform');
        var bb; try { bb = g.getBBox(); } catch (e) { return; }
        if (!bb || !bb.width) return;
        var fw = +g.getAttribute('data-fw'), fh = +g.getAttribute('data-fh');
        var k = Math.min(1, fw * 0.94 / bb.width, fh * 0.94 / bb.height);
        if (k >= 1) return;
        var cx = g.getAttribute('data-cx'), cy = g.getAttribute('data-cy');
        g.setAttribute('transform', (rot ? rot + ' ' : '') + 'translate(' + cx + ' ' + cy + ') scale(' + k.toFixed(3) + ') translate(' + (-cx) + ' ' + (-cy) + ')');
      });
      if (!this._fontsHooked && document.fonts && document.fonts.ready) {
        this._fontsHooked = true;
        document.fonts.ready.then(function () { self.fitText(); });
      }
    }

    drawPreview() {
      if (!this.preview) return;
      var self = this;
      if (this.cfg.design_imgs) {
        // 23-oct-2026 (María): foto del diseño elegido; el texto que escriben no se dibuja
        var di = this.cfg.design_imgs, df = this.fields.filter(function (f) { return f.key === di.key; })[0];
        var dv = df && this.values[df._id], file = dv && di.files[dv];
        var js = document.querySelector('script[src*="mm-pz.js"]');
        this.sideTabs.innerHTML = '';
        this.preview.innerHTML = file && js ? '<img class="mm-pz__designimg' + (di.square ? ' mm-pz__designimg--sq' : '') + '" src="' + js.src.replace(/mm-pz\.js.*$/, file) + '" alt="" width="500" height="500">' : '';
        return;
      }
      var groups = {};   // lado → líneas
      var order = [];
      this.fields.forEach(function (f) {
        if ((f.type !== 'line' && f.type !== 'area') || !self.visible(f)) return;
        var side = f.side || 'Front';
        if (!groups[side]) { groups[side] = []; order.push(side); }
        f._inputs.forEach(function (i) {
          if (f.wrap && i.value.trim()) wrapText(textToSym(i.value), f.wrap).forEach(function (l) { groups[side].push(l); });
          else groups[side].push(textToSym(i.value || ''));
        });
      });
      if (!order.length) {
        this.sideTabs.innerHTML = '';
        if (this.cfg.qr && this.engMode().split) { this.drawSplit([], false, this.engMode()); return; }
        this.preview.innerHTML = this.logoMode() ? this.svg([], true) : this.cfg.qr ? this.svg([], false, { symbol: this.engMode().symbol }) : '';
        return;
      }
      if (order.indexOf(this.side) === -1) this.side = order[0];
      this.sideTabs.innerHTML = '';
      var linesOf = function (side) {
        var ls = groups[side].slice(); var last = ls.length; while (last > 1 && !ls[last - 1]) last--;
        ls = ls.slice(0, Math.max(last, 1));
        if (ls.some(Boolean)) return { lines: ls, ghost: false };
        var ex = [];
        self.fields.forEach(function (f) {
          if ((f.type !== 'line' && f.type !== 'area') || !self.visible(f) || (f.side || 'Front') !== side) return;
          (f.type === 'area' ? f.ph : [f.ph]).forEach(function (p) { if (p) ex.push(textToSym(p.replace(/^Ex:\s*/, ''))); });
        });
        return { lines: ex.slice(0, 4), ghost: true };
      };
      if (order.length > 1) {
        // 22-oct-2026 (María): todas las caras juntas, una al lado de la otra (antes había que cambiar de pestaña)
        var em0 = this.engMode();
        var parts = order.map(function (s) {
          var d = linesOf(s);
          var withSym = em0.symbol && (!em0.side || em0.side === s);
          return self.svg(d.lines, d.ghost, { symbol: withSym, small: withSym && em0.small, label: s }, true);
        });
        var vert = /^(pendant-rect|dogtag|bar-v|watch|round|mouse|heart)$/.test(this.cfg.shape || '');
        var html = '';
        if (vert) {
          var cut = Math.max(0, parts[0].W - parts[0].pw - 36), wsum = 0;
          parts.forEach(function (p, i) { html += '<g transform="translate(' + (wsum - (i ? cut / 2 : 0)) + ',0)">' + p.inner + '</g>'; wsum += p.W - (i ? cut : cut / 2); });
          this.preview.innerHTML = '<svg viewBox="' + (cut / 2) + ' 0 ' + (wsum - cut / 2) + ' ' + parts[0].H + '" role="img" focusable="false">' + html + '</svg>';
        } else {
          var hsum = 0;
          parts.forEach(function (p) { html += '<g transform="translate(0,' + hsum + ')">' + p.inner + '</g>'; hsum += p.H; });
          this.preview.innerHTML = '<svg viewBox="0 0 ' + parts[0].W + ' ' + hsum + '" role="img" focusable="false">' + html + '</svg>';
        }
        return;
      }
      var lines = groups[this.side];
      var last = lines.length; while (last > 1 && !lines[last - 1]) last--;
      lines = lines.slice(0, Math.max(last, 1));
      var anyText = lines.some(Boolean);
      if (!anyText) {
        // muestra los ejemplos en gris mientras está vacío
        var ex = [];
        this.fields.forEach(function (f) {
          if ((f.type !== 'line' && f.type !== 'area') || !self.visible(f) || (f.side || 'Front') !== self.side) return;
          (f.type === 'area' ? f.ph : [f.ph]).forEach(function (p) { if (p) ex.push(textToSym(p.replace(/^Ex:\s*/, ''))); });
        });
        lines = ex.slice(0, 4);
      }
      var em = this.engMode();
      if (em.split) { this.drawSplit(lines, !anyText, em); return; }
      // Si la única cara con texto es el reverso (Handwriting Pendant: al frente va la
      // letra subida), se rotula "Back" para que no parezca el frente.
      if (this.cfg.qr && this.side === 'Back') { this.drawQrBack(lines, !anyText, em); return; }
      this.preview.innerHTML = this.svg(lines, !anyText, { symbol: em.symbol && (!em.side || em.side === this.side),
        label: this.side === 'Back' ? 'Back' : '' });
    }


    // 27-oct-2026 (María): en fichas QR el texto de atrás va en su propia placa "Back";
    // el frente queda con el QR (y el símbolo, si la opción lo lleva), nunca con el texto al lado.
    drawQrBack(lines, ghost, em) {
        var a = this.svg([], false, { symbol: em.symbol, label: 'Front' }, true);
        var b = this.svg(lines, ghost, { symbol: !!this.cfg.back_symbol, noqr: true, label: 'Back' }, true);
        this.stackTwo(a, b);
    }
    stackTwo(a, b) {
        if (/^(pendant-rect|dogtag|bar-v|watch|round|mouse|heart)$/.test(this.cfg.shape || '')) {
          var c2 = Math.max(0, (a.W - a.pw) / 2 - 18);
          this.preview.innerHTML = '<svg viewBox="' + c2 + ' 0 ' + (a.W + b.W - 4 * c2) + ' ' + Math.max(a.H, b.H) + '" role="img" focusable="false">' +
            '<g>' + a.inner + '</g><g transform="translate(' + (a.W - 2 * c2) + ',0)">' + b.inner + '</g></svg>';
        } else {
          this.preview.innerHTML = '<svg viewBox="0 0 ' + a.W + ' ' + (a.H + b.H) + '" role="img" focusable="false">' +
            '<g>' + a.inner + '</g><g transform="translate(0,' + a.H + ')">' + b.inner + '</g></svg>';
        }
    }

    drawSplit(lines, ghost, em) {
        // Opción "símbolo afuera y texto adentro": dos placas, como en la imagen de Engraving Options
        var backy = this.fields.some(function (f) { return f.side === 'Back'; });
        var a = this.svg([], true, { symbol: true, only: true, small: em.small, noqr: true, label: backy ? 'Front' : 'Outside' }, true);
        var b = this.svg(lines, ghost, { symbol: false, label: backy ? 'Back' : 'Inside' }, true);
        if (/^(pendant-rect|dogtag|bar-v|watch|round|mouse|heart)$/.test(this.cfg.shape || '')) {
          // placas verticales: Outside e Inside lado a lado, como en la imagen de Engraving Options
          var c2 = Math.max(0, (a.W - a.pw) / 2 - 18);   // aire a cada lado de la placa que sobra
          this.preview.innerHTML = '<svg viewBox="' + c2 + ' 0 ' + (a.W + b.W - 4 * c2) + ' ' + Math.max(a.H, b.H) + '" role="img" focusable="false">' +
            '<g>' + a.inner + '</g><g transform="translate(' + (a.W - 2 * c2) + ',0)">' + b.inner + '</g></svg>';
        } else {
          this.preview.innerHTML = '<svg viewBox="0 0 ' + a.W + ' ' + (a.H + b.H) + '" role="img" focusable="false">' +
            '<g>' + a.inner + '</g><g transform="translate(0,' + a.H + ')">' + b.inner + '</g></svg>';
        }
    }

    // Lee la opción de grabado / símbolo médico (22-oct-2026): con o sin símbolo, o símbolo afuera + texto adentro.
    engMode() {
      var self = this, out = { symbol: !!this.cfg.symbol, split: false };
      if (this.cfg.symbol_side) out.side = this.cfg.symbol_side;   // p. ej. solo en el frente
      if (!this.cfg.medical) return out;
      // Variante "With / Without medical symbol" (p. ej. Slide-On)
      var vt = this.variantTitle();
      if (/without (a )?med(ical)? symbol|no med(ical)? symbol/.test(vt)) out.symbol = false;
      else if (/with (a )?med(ical)? symbol|and medic(al)? symbol/.test(vt)) out.symbol = true;
      this.fields.forEach(function (f) {
        if (f.type !== 'choice' || !self.visible(f)) return;
        var lbl = ((f.label || '') + ' ' + (f.prop || '')).toLowerCase();
        var v = (self.values[f._id] || f.default || '').toLowerCase();
        if (!v) return;
        if (/engraving (option|design)/.test(lbl)) {
          var num = v.replace(/^(option|design)\s*/, '').trim();
          var map = self.cfg.eng_map || { '1': { symbol: true }, '2': {}, '3': { split: true }, '4': { split: true, small: true } };
          if (/^\d+$/.test(num)) { var mm = map[num] || {}; out.symbol = !!mm.symbol; out.split = !!mm.split; out.small = !!mm.small; if (mm.side) out.side = mm.side; return; }
          if (/inside/.test(v) && /symbol/.test(v)) out.split = true;
          else if (/without/.test(v)) out.symbol = false;
          else if (/symbol/.test(v)) out.symbol = true;
        } else if (/medical symbol|med symbol/.test(lbl)) {
          // "Yes" / "With medical symbol" = con símbolo; "No" / "Only text" / "Without…" = sin símbolo
          out.symbol = /^yes|with/.test(v) && !/without|only text|^no/.test(v);
        }
      });
      return out;
    }

    // Estrella de la vida (contorno) con bastón y serpiente, como en las imágenes de Engraving Options.
    starOfLife(cx, cy, s, c) {
      var k = s / MED_SYMBOL.w, x = cx - s / 2, y = cy - (MED_SYMBOL.h * k) / 2;
      return '<g transform="translate(' + x.toFixed(2) + ' ' + y.toFixed(2) + ') scale(' + k.toFixed(4) + ')">' +
        MED_SYMBOL.d.map(function (d) { return '<path d="' + d + '" fill="' + c + '" fill-rule="evenodd"/>'; }).join('') + '</g>';
    }

    svg(lines, ghost, opt, raw) {
      opt = opt || {};
      var shape = this.cfg.shape || 'bar-h';
      var m = this.metal(); var font = this.font();
      var W = 360, H = 200, box;
      var S = ({
        'bar-h': [300, 84, 12], 'cuff': [330, 62, 30], 'band': [330, 74, 37], 'bar-v': [84, 300, 12],
        'tag': [230, 130, 20], 'watch': [250, 150, 22], 'card': [320, 196, 14], 'dogtag': [170, 250, 46],
        'round': [190, 190, 95], 'heart': [190, 190, 0], 'nametag': [310, 104, 10], 'oval-link': [330, 104, 52],
        // 22-oct-2026: placas reales según la imagen de Engraving Options de cada producto
        'pendant-rect': [190, 278, 10], 'bar-thin': [330, 55, 6], 'cord-plate': [300, 86, 12], 'slim-link': [300, 56, 28],
        'clamp-plate': [270, 180, 12], 'slot-tag': [270, 135, 14], 'mouse': [180, 180, 90]
      })[shape] || [300, 84, 12];
      if (shape === 'watch') S = [230, 177, 22];   // las placas de reloj reales son ~1.3:1
      var w = S[0], h = S[1], r = S[2];
      var ratio = Number(this.cfg.ratio) || 0;
      if (ratio && shape === 'clamp-plate') h = Math.round(w / ratio);
      if (ratio && shape === 'bar-v') w = Math.round(h / ratio);
      if (shape === 'bar-v' || shape === 'dogtag') { W = 360; H = 320; }
      if (shape === 'pendant-rect' || shape === 'mouse') { W = 360; H = 320; }
      if (shape === 'card') { H = 240; }
      var x = (W - w) / 2, y = (H - h) / 2;
      var gid = 'mmg' + Math.random().toString(36).slice(2, 7);
      var defs = '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="' + m[0] + '"/><stop offset="1" stop-color="' + m[1] + '"/></linearGradient></defs>';
      var body;
      if (shape === 'heart') {
        body = '<path d="M180 290 C 60 200, 40 120, 100 80 C 140 55, 175 75, 180 105 C 185 75, 220 55, 260 80 C 320 120, 300 200, 180 290 Z" transform="translate(0,-60) scale(1)" fill="' + m[0] + '" stroke="#2b2220" stroke-width="1.8"/>';
        box = [120, 70, 120, 110];
      } else {
        // Estilo dibujo de línea (22-oct-2026), como las imágenes de Engraving Options
        var ink = '#2b2220', sw = 1.8;
        body = '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="' + r + '" fill="' + m[0] + '" stroke="' + ink + '" stroke-width="' + sw + '"/>';
        if (shape === 'oval-link') {
          body = '<ellipse cx="' + (W / 2) + '" cy="' + (H / 2) + '" rx="' + (w / 2) + '" ry="' + (h / 2) + '" fill="' + m[0] + '" stroke="' + ink + '" stroke-width="' + sw + '"/>' +
            '<circle cx="' + (x + 20) + '" cy="' + (H / 2) + '" r="6.5" fill="#fff" stroke="' + ink + '" stroke-width="1.4"/>' +
            '<circle cx="' + (x + w - 20) + '" cy="' + (H / 2) + '" r="6.5" fill="#fff" stroke="' + ink + '" stroke-width="1.4"/>';
        }
        var hole = function (cx0, cy0, rr) { return '<circle cx="' + cx0 + '" cy="' + cy0 + '" r="' + rr + '" fill="#fff" stroke="' + ink + '" stroke-width="1.3"/>'; };
        if (shape === 'dogtag') body += hole(W / 2, y + 22, 7);
        if (shape === 'bar-v') body += hole(W / 2, y + 14, 5);
        if (shape === 'pendant-rect') body += hole(W / 2, y + h * 0.07, w * 0.045);
        if (shape === 'bar-thin') body += hole(x + w * 0.04, H / 2, h * 0.11) + hole(x + w * 0.96, H / 2, h * 0.11);
        if (shape === 'cord-plate') body += hole(x + w * 0.06, H / 2, h * 0.08) + hole(x + w * 0.94, H / 2, h * 0.08);
        if (shape === 'slim-link') body = '<circle cx="' + (x - 9) + '" cy="' + (H / 2) + '" r="9" fill="none" stroke="' + ink + '" stroke-width="1.6"/><circle cx="' + (x + w + 9) + '" cy="' + (H / 2) + '" r="9" fill="none" stroke="' + ink + '" stroke-width="1.6"/>' + body;
        if (shape === 'clamp-plate') body += '<rect x="' + x + '" y="' + y + '" width="' + (w * 0.08) + '" height="' + h + '" rx="' + r + '" fill="' + m[1] + '" stroke="' + ink + '" stroke-width="1.3"/><rect x="' + (x + w * 0.92) + '" y="' + y + '" width="' + (w * 0.08) + '" height="' + h + '" rx="' + r + '" fill="' + m[1] + '" stroke="' + ink + '" stroke-width="1.3"/>';
        if (shape === 'slot-tag') { var sw2 = w * 0.05, sh2 = h * 0.6; body += '<rect x="' + (x + w * 0.05) + '" y="' + (H / 2 - sh2 / 2) + '" width="' + sw2 + '" height="' + sh2 + '" rx="' + (sw2 / 2) + '" fill="#fff" stroke="' + ink + '" stroke-width="1.3"/><rect x="' + (x + w * 0.9) + '" y="' + (H / 2 - sh2 / 2) + '" width="' + sw2 + '" height="' + sh2 + '" rx="' + (sw2 / 2) + '" fill="#fff" stroke="' + ink + '" stroke-width="1.3"/>'; }
        if (shape === 'mouse') {
          var R = 82, mx = W / 2, my = H / 2 + 28;
          body = '<circle cx="' + (mx - R * 0.82) + '" cy="' + (my - R * 0.82) + '" r="' + (R * 0.55) + '" fill="' + m[0] + '" stroke="' + ink + '" stroke-width="' + sw + '"/>' +
            '<circle cx="' + (mx + R * 0.82) + '" cy="' + (my - R * 0.82) + '" r="' + (R * 0.55) + '" fill="' + m[0] + '" stroke="' + ink + '" stroke-width="' + sw + '"/>' +
            '<circle cx="' + mx + '" cy="' + my + '" r="' + R + '" fill="' + m[0] + '" stroke="' + ink + '" stroke-width="' + sw + '"/>' +
            '<circle cx="' + mx + '" cy="' + (my - R - 8) + '" r="6" fill="none" stroke="' + ink + '" stroke-width="1.6"/>';
          x = mx - R; y = my - R; w = h = R * 2;
        }
        if (shape === 'band') body = '<rect x="' + (x - 6) + '" y="' + (y + 6) + '" width="' + (w + 12) + '" height="' + (h - 12) + '" rx="' + r + '" fill="' + m[1] + '" opacity=".35"/>' + body;
        var PAD = { 'round': 0.15, 'mouse': 0.2, 'oval-link': 0.16, 'cord-plate': 0.12, 'bar-thin': 0.09, 'clamp-plate': 0.12, 'slot-tag': 0.14, 'slim-link': 0.06 };
        var pad = PAD[shape] || 0.08;
        var topPad = shape === 'dogtag' ? 0.2 : shape === 'pendant-rect' ? 0.17 : shape === 'bar-v' ? 0.1 : pad;
        box = [x + w * pad, y + h * topPad, w * (1 - 2 * pad), h * (1 - topPad - pad)];
      }
      var qr = '', qCard = 0, qMid = 0, qShift = 0, qRight = 0;
      if (shape === 'card' && this.cfg.qr) {   // 27-oct-2026 (María): en la tarjeta el símbolo mide lo mismo que el QR
        qCard = Math.min(box[3] * 0.78, box[2] * 0.36); qMid = box[1] + (box[3] - 16) / 2;
      }
      if (this.cfg.qr && !opt.noqr && /^(watch|card|round|dogtag|pendant-rect)$/.test(shape)) {
        var stack = shape === 'round' || shape === 'dogtag' || shape === 'pendant-rect';
        var q = stack ? Math.min(box[2] * 0.62, box[3] * 0.5) : Math.min(box[3], box[2] * 0.4) * 0.8;
        var qx = stack ? W / 2 - q / 2 : box[0] + box[2] - q;          // QR a la derecha (como en las fotos)
        var qy = stack ? box[1] + box[3] - q : box[1] + (box[3] - q) / 2; // apilado: QR abajo
        if (shape === 'card') { q = qCard; qy = qMid - q / 2; qShift = box[2] * 0.05; qx -= qShift; qRight = qx + q; }   // aire con el borde derecho (María, 27-oct-2026)
        qr = '<g opacity=".9">' + this.qrGlyph(qx, qy, q, m[2]) + '</g>';
        if (shape === 'card') qr += '<text x="' + (qx + q / 2) + '" y="' + (qy + q + 14) + '" text-anchor="middle" font-family="Arial, sans-serif" font-weight="700" font-size="9.5" fill="' + m[2] + '">SCAN THE QR CODE</text>';
        if (stack) box = [box[0], box[1], box[2], box[3] - q - 8]; else box = [box[0], box[1], box[2] - q - 12 - qShift, box[3]];
      }
      var logo = '', mode = this.logoMode();
      if (mode) {
        var full = mode === 'full';
        var lw = full ? box[2] : box[2] * 0.3, lx = box[0], ly = box[1], lh0 = box[3];
        if (this.logoURL) logo = '<image href="' + this.logoURL + '" x="' + lx + '" y="' + ly + '" width="' + lw + '" height="' + lh0 + '" preserveAspectRatio="xMidYMid meet"/>';
        else logo = '<g><rect x="' + (lx + 2) + '" y="' + (ly + 2) + '" width="' + (lw - 4) + '" height="' + (lh0 - 4) + '" rx="6" fill="none" stroke="' + m[2] + '" stroke-opacity=".45" stroke-dasharray="4 3"/>' +
          '<text x="' + (lx + lw / 2) + '" y="' + (ly + lh0 / 2 + 4) + '" text-anchor="middle" font-family="Arial, sans-serif" font-size="11" letter-spacing="1" fill="' + m[2] + '" fill-opacity=".6">' + (full ? 'YOUR DESIGN' : 'LOGO') + '</text></g>';
        if (full) lines = [];
        else box = [box[0] + lw + 10, box[1], box[2] - lw - 10, box[3]];
      }
      var sym = '';
      if (opt.symbol && !mode) {
        var ss = Math.min(box[3] * 0.85, box[2] * 0.26, 74);
        var sOnly = Math.min(box[3] * 0.6, box[2] * 0.62, 96);
        if (opt.only && opt.small) { var s2 = sOnly * 0.5; sym = this.starOfLife(box[0] + box[2] - s2 / 2, box[1] + box[3] - s2 / 2, s2, m[2]); lines = []; }   // opción 4: símbolo chico abajo a la derecha
        else if (opt.only) { sym = this.starOfLife(box[0] + box[2] / 2, box[1] + box[3] / 2, sOnly, m[2]); lines = []; }
        else if (opt.small) {   // símbolo chico abajo a la derecha y el texto encima (opción 4 con texto al frente)
          var s3 = sOnly * 0.5; sym = this.starOfLife(box[0] + box[2] - s3 / 2, box[1] + box[3] - s3 / 2, s3, m[2]);
          box = [box[0], box[1], box[2], box[3] - s3 - 4];
        }
        else if (qCard) {
          // tarjeta QR: símbolo del mismo alto y ancho que el QR, nunca más grande, alineado con el QR
          var sc = qCard * Math.min(1, MED_SYMBOL.w / MED_SYMBOL.h);
          if (!lines.some(Boolean)) {   // misma separación del borde que el QR (María, 27-oct-2026)
            var mg = qRight ? x + w - qRight : box[0] - x;
            sym = this.starOfLife(x + mg + sc / 2, qMid, sc, m[2]); lines = []; }
          else { sym = this.starOfLife(box[0] + qCard / 2, qMid, sc, m[2]); box = [box[0] + qCard + 12, box[1], box[2] - qCard - 12, box[3]]; }
        }
        else if (/^(pendant-rect|dogtag|watch|round|bar-v)$/.test(shape)) {
          // en placas verticales o de reloj el símbolo va arriba al centro
          ss = Math.min(box[2] * 0.42, box[3] * 0.34, 64);
          sym = this.starOfLife(box[0] + box[2] / 2, box[1] + ss / 2, ss, m[2]); box = [box[0], box[1] + ss + 6, box[2], box[3] - ss - 6];
        }
        else { sym = this.starOfLife(box[0] + ss / 2 + 2, box[1] + box[3] / 2, ss, m[2]); box = [box[0] + ss + 10, box[1], box[2] - ss - 10, box[3]]; }
      }
      var label = opt.label ? '<text x="' + (W / 2) + '" y="16" text-anchor="middle" font-family="Poppins, Arial, sans-serif" font-size="13" fill="#6B5249">' + opt.label + '</text>' : '';
      var emph = this.pick('emph'), big = /bigger/.test(emph) ? 1.4 : 1, bold1 = /bolder/.test(emph);
      var n = Math.max(lines.length, 1);
      var longest = Math.max.apply(null, lines.map(function (l) { return l.length; }).concat([6]));
      var vertical = shape === 'bar-v';
      var bw = vertical ? box[3] : box[2], bh = vertical ? box[2] : box[3];
      var fs = Math.min(bh / ((n - 1 + big) * 1.2), bw / (longest * 0.52 * (lines.length > 1 ? 1 : big)), 34);
      var lh = fs * 1.22;
      var cx = box[0] + box[2] / 2, cy = box[1] + box[3] / 2;
      var italic = /chancery|corsiva|cursive/i.test(font.family);
      var rot = vertical ? 'rotate(90 ' + cx + ' ' + cy + ')' : '';
      var t = '<g class="mm-pz__txt" data-fw="' + bw.toFixed(1) + '" data-fh="' + bh.toFixed(1) + '" data-cx="' + cx + '" data-cy="' + cy + '" data-rot="' + rot + '"' + (rot ? ' transform="' + rot + '"' : '') + ' font-family=\'MM Sym, ' + font.family.replace(/'/g, '') + '\' font-weight="' + font.weight + '"' + (italic ? ' font-style="italic"' : '') + ' font-size="' + fs.toFixed(1) + '" fill="' + m[2] + '" text-anchor="middle"' + (ghost ? ' opacity=".38"' : '') + '>';
      var tot = (n - 1 + big) * lh, yy = cy - tot / 2;
      lines.forEach(function (l, i) {
        var f1 = i === 0 ? big : 1;
        yy += lh * f1;
        t += '<text x="' + cx + '" y="' + (yy - lh * f1 * 0.28).toFixed(1) + '"' + (f1 !== 1 ? ' font-size="' + (fs * f1).toFixed(1) + '"' : '') + (i === 0 && bold1 ? ' font-weight="700"' : '') + '>' + l.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</text>';
      });
      t += '</g>';
      var inner = defs + label + body + qr + logo + sym + t;
      if (raw) return { inner: inner, W: W, H: H, pw: w };
      return '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" focusable="false">' + inner + '</svg>';
    }

    // name tags: 'side' = logo + texto, 'full' = solo logo / diseño propio, '' = sin logo
    logoMode() {
      var L = this.cfg.logo; if (!L) return '';
      var v = this.pick(L.key);
      if (!v) return '';
      if ((L.full || []).some(function (x) { return x.toLowerCase() === v; })) return 'full';
      if ((L.side || []).some(function (x) { return x.toLowerCase() === v; })) return 'side';
      return '';
    }

    qrGlyph(x, y, s, c) {
      var u = s / 7, out = '<rect x="' + x + '" y="' + y + '" width="' + s + '" height="' + s + '" fill="none"/>';
      var cells = [[0,0],[1,0],[2,0],[0,1],[2,1],[0,2],[1,2],[2,2],[4,0],[5,0],[6,0],[4,1],[6,1],[4,2],[5,2],[6,2],[0,4],[1,4],[2,4],[0,5],[2,5],[0,6],[1,6],[2,6],[4,4],[6,4],[5,5],[4,6],[6,6],[3,3],[5,3],[3,5]];
      cells.forEach(function (p) { out += '<rect x="' + (x + p[0] * u) + '" y="' + (y + p[1] * u) + '" width="' + u + '" height="' + u + '" fill="' + c + '"/>'; });
      return out;
    }

    /* ── validar y agregar add-ons ── */
    clearErr(f) { var b = this.querySelector('[data-fid="' + f._id + '"] .mm-pz__err'); if (b) b.hidden = true; }
    validate() {
      var self = this, first = null;
      this.fields.forEach(function (f) {
        if (!self.visible(f)) return;
        var ok = true;
        if (f.type === 'choice') ok = !f.required || !!self.values[f._id];
        else if (f.required) ok = f.type === 'file' ? !!(f._inputs[0].files && f._inputs[0].files.length) : !!(f._inputs[0].value.trim());
        var err = self.querySelector('[data-fid="' + f._id + '"] .mm-pz__err');
        if (ok && f.wrap && f.maxlines && wrapText(f._inputs[0].value, f.wrap).length > f.maxlines) {
          ok = false;
          if (err) err.textContent = 'Too long: it must fit in ' + f.maxlines + ' lines of ' + f.wrap + ' characters. Please shorten it.';
        } else if (err && f.wrap) err.textContent = f.err || 'Please fill in at least the first line.';
        if (err) err.hidden = ok;
        if (!ok && !first) first = self.querySelector('[data-fid="' + f._id + '"]');
      });
      if (this.okBox && !this.okBox.checked) { this.okErr.hidden = false; if (!first) first = this.okBox.closest('.mm-pz__ok'); }
      if (first) { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); var i = first.querySelector('input:not([type=hidden])'); if (i) i.focus({ preventScroll: true }); }
      return !first;
    }
    itemWord() {
      var t = (this.prod.title || '').toLowerCase();
      return /watch/.test(t) ? 'watch tag' : /bracelet|band/.test(t) ? 'bracelet' : /necklace|pendant/.test(t) ? 'necklace' : 'tag';
    }
    addons() {
      var self = this, out = [];
      this.fields.forEach(function (f) {
        if (f.type !== 'choice' || !self.visible(f)) return;
        var o = f.options.find(function (x) { return x.v === self.values[f._id]; });
        if (o && o.addon) out.push({ id: o.addon, quantity: o.qty || 1, properties: { _for: self.prod.title, _option: (f.cart_label || f.label) + ': ' + o.v } });
      });
      return out;
    }
    bindForm() {
      var self = this;
      // variante cambiada → recalcular campos que dependen de ella
      document.addEventListener('change', function (e) {
        if (e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(function () { self.update(); }, 60);
      });
      document.addEventListener('submit', function (e) {
        var f = self.form();
        if (!f || e.target !== f) return;
        if (self._passing) { self._passing = false; return; }
        self.update();
        if (!self.validate()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        var items = self.addons();
        if (!items.length) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var qtyIn = f.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"][form="' + self.formId + '"]');
        var q = qtyIn ? Math.max(1, Number(qtyIn.value) || 1) : 1;
        items.forEach(function (it) { it.quantity = it.quantity * q; });
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).catch(function () {}).then(function () {
          self._passing = true;
          if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        });
      }, true);
    }
  }
  customElements.define('mm-personalizer', MMPersonalizer);
})();
